/* MUI */
import { Box } from '@mui/material';

/*  Components  */
import { CreatePublisherModal } from 'application/Home/GlobalAdmin/Applications/Modals/CreatePublisherModal';

/* Hooks */
import { useFetchPublishers } from 'hooks/dataAccess/Publisher/publisher';

/*  React  */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ObjectPicker from './Components/ObjectPicker';

const makePayload = ({
    t,
    allowAdd,
    publishers,
    setLoaded,
    setObjectPayload
}) => {
    setLoaded(false);
    const objectPayload = publishers.map(({ id, name }) => ({
        componentToDisplay: <Box width="100%">{name}</Box>,
        id,
        name
    }));

    if (allowAdd) {
        objectPayload.unshift({
            componentToDisplay: (
                <Box width="100%">{t('Picker.publisher.addNew')}</Box>
            ),
            id: 'new',
            name: 'Add New Publisher'
        });
    }

    setObjectPayload(objectPayload);
    setLoaded(true);
};

export const PublisherPicker = (props) => {
    const { publisherId, allowAdd, onChange } = props;
    const [loaded, setLoaded] = useState(false);
    const [addPublisher, setAddPublisher] = useState(false);
    const [objectPayload, setObjectPayload] = useState([]);
    const { t } = useTranslation();

    const {
        publishers,
        loading: loadingPublishers,
        refetchData
    } = useFetchPublishers();

    useEffect(() => {
        if (loadingPublishers) return;
        makePayload({ allowAdd, publishers, setLoaded, setObjectPayload, t });
    }, [t, allowAdd, publishers, loadingPublishers]);

    const onSelect = (id) => {
        if (id === 'new') {
            setAddPublisher(true);
        } else {
            setAddPublisher(false);
            onChange(id);
        }
    };

    const onSuccess = (tenantId) => {
        onChange(tenantId);
        refetchData();
    };

    return (
        loaded && (
            <>
                <CreatePublisherModal
                    open={addPublisher}
                    onClose={() => {
                        setAddPublisher(false);
                    }}
                    onSuccessFn={onSuccess}
                />
                <ObjectPicker
                    {...props}
                    onChange={onSelect}
                    value={publisherId || ''}
                    objectPayload={objectPayload}
                    objectNameField="name"
                    objectNameFieldVisualOnly="componentToDisplay"
                    visualOnlyDefault={undefined}
                />
            </>
        )
    );
};
